/**
 * Asks the server whether it already has a fresh Fingerprint Pro
 * identification on file for this device, so the paid `identify()` call in
 * fingerprintProClient.ts can be skipped on a retry from the same browser
 * (docs/detection-and-risk.md, "Fingerprint Pro identity reuse").
 *
 * Fails to `false` (do the real identification) on any network error or
 * non-2xx response: a wrong answer here only ever costs an extra
 * identification, never a missed one, so there is nothing to surface to the
 * user.
 */
export async function checkFingerprintProReuse(
  indexeddb: string | null,
  localstorage: string | null,
): Promise<boolean> {
  try {
    const response = await fetch("/api/fingerprint-precheck", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ indexeddb, localstorage }),
    });
    if (!response.ok) return false;
    const body = (await response.json()) as { skipFingerprintPro?: boolean };
    return body.skipFingerprintPro === true;
  } catch {
    return false;
  }
}
